import { render, staticRenderFns } from "./WvSteakHouseDessertSection.vue?vue&type=template&id=2ee9c944&scoped=true"
import script from "./WvSteakHouseDessertSection.vue?vue&type=script&lang=ts"
export * from "./WvSteakHouseDessertSection.vue?vue&type=script&lang=ts"
import style0 from "./WvSteakHouseDessertSection.vue?vue&type=style&index=0&id=2ee9c944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee9c944",
  null
  
)

export default component.exports